import { render, staticRenderFns } from "./tTd.vue?vue&type=template&id=9b040ba6"
import script from "./tTd.vue?vue&type=script&lang=js"
export * from "./tTd.vue?vue&type=script&lang=js"
import style0 from "./tTd.vue?vue&type=style&index=0&id=9b040ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports